import './styles.scss';

const ProductSidebar = ({ title, data }) => (
    <div className="product-sidebar">
        <div className="description-demibold product-sidebar__title">{title}</div>
        <div className="product-sidebar-cards">
            {data.map((item, index) => (
                <a href="/#" key={index} className="product-sidebar-card">
                    <img src={item.img} alt="" />
                </a>
            ))}
        </div>
    </div>
);

export default ProductSidebar;
